import { ArrowRight, Copy } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { CheckoutSteps } from "../components/brand";
import { Seo } from "../components/Seo";
import { useToast } from "../state/toast";

export function ConfirmationPage() {
  const { orderNumber = "" } = useParams();
  const toast = useToast();
  const copy = () => navigator.clipboard.writeText(orderNumber).then(() => toast.success("Order number copied."), () => undefined);
  return <section className="container-page pb-10 pt-8 md:pt-12">
    <Seo title="Order received" path={`/order/${orderNumber}/confirmed`} noindex />
    <div className="mx-auto max-w-2xl">
      <CheckoutSteps current={3} />
      <h1 className="mt-8 font-display text-[2.75rem] leading-[1.02] text-cocoa md:text-6xl">Receipt received. Thank you!</h1>
      <p className="mt-5 text-lg leading-relaxed text-muted">Your payment is now waiting to be checked. Making starts as soon as it’s verified.</p>

      <div className="mt-10 rounded-xl bg-frosting p-6">
        <p className="text-sm font-bold text-muted">Your order number</p>
        <button type="button" onClick={copy} className="mt-1 inline-flex flex-wrap items-center gap-2 text-2xl font-bold tabular-nums tracking-wide text-cocoa hover:text-ribbon-ink">{orderNumber}<Copy size={18} /></button>
        <p className="mt-2 text-sm text-muted">Keep this number. Track your order with it and the email or mobile number from checkout.</p>
      </div>

      <h2 className="mt-12 text-lg font-bold">What happens next</h2>
      <ol className="mt-4 divide-y divide-line border-y border-line">
        {[
          ["Payment check", "Your receipt is reviewed against the amount due."],
          ["Into the making queue", "Once approved, your order joins the queue and gets made."],
          ["If something’s unclear", "Tracking will show what needs fixing and let you upload a new receipt."]
        ].map(([title, text], index) => <li key={title} className="flex gap-4 py-4">
          <span className="font-display text-xl leading-6 text-ribbon">{index + 1}</span>
          <div><p className="font-bold">{title}</p><p className="mt-0.5 text-[15px] text-muted">{text}</p></div>
        </li>)}
      </ol>

      <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-4">
        <Link to="/track" className="btn-primary">Track this order <ArrowRight size={18} /></Link>
        <Link to="/shop" className="link-quiet">Keep browsing</Link>
      </div>
    </div>
  </section>;
}
